import React from 'react';
import { ShieldCheck } from 'lucide-react';
type QuoteFormProps = {
  onSubmit: (e: React.FormEvent) => void;
};
export function QuoteForm({
  onSubmit
}: QuoteFormProps) {
  return <form onSubmit={onSubmit} className="space-y-3" data-id="element-82">
      <div data-id="element-83">
        <label htmlFor="fullName" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-84">
          Full Name
        </label>
        <input type="text" id="fullName" name="fullName" required placeholder="John Smith" autoComplete="name" className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue transition-colors outline-none text-navy-900 placeholder:text-slate-400" data-id="element-85" />
      </div>
      <div data-id="element-86">
        <label htmlFor="phone" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-87">
          Phone Number
        </label>
        <input type="tel" id="phone" name="phone" required placeholder="(555) 123-4567" autoComplete="tel" className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue transition-colors outline-none text-navy-900 placeholder:text-slate-400" data-id="element-88" />
      </div>
      <div data-id="element-89">
        <label htmlFor="email" className="block text-sm font-semibold text-navy-900 mb-1.5" data-id="element-90">
          Email Address
        </label>
        <input type="email" id="email" name="email" required placeholder="john@email.com" autoComplete="email" className="w-full px-4 py-2.5 rounded-xl border border-slate-300 focus:ring-2 focus:ring-brand-blue focus:border-brand-blue transition-colors outline-none text-navy-900 placeholder:text-slate-400" data-id="element-91" />
      </div>

      <div className="bg-slate-50 p-2.5 rounded-lg border border-slate-100 text-xs text-slate-600 flex items-start gap-2" data-id="element-92">
        <ShieldCheck className="w-4 h-4 text-brand-blue shrink-0 mt-0.5" data-id="element-93" />
        <p data-id="element-94">
          Kosin's will ask for vehicle details when they call to ensure
          accuracy.
        </p>
      </div>

      <button type="submit" className="w-full bg-brand-blue hover:bg-brand-hover text-white font-bold text-base lg:text-lg py-3 px-6 rounded-xl transition-colors shadow-lg shadow-brand-blue/20 flex justify-center items-center gap-2 group" data-id="element-95">
        Request My Free Auto Glass Quote
        <span className="group-hover:translate-x-1 transition-transform" data-id="element-96">
          →
        </span>
      </button>
    </form>;
}